/**
 * @file 帮助中心功能合集
 * @author yangwei(yangwei14.com)
 */

import {addEvent} from '../../common/util';
import '../common/header';
import './help.less';

(function () {

    // 点击toc
    const tocs = document.getElementsByClassName('toc-item');

    function activeToc(el) {
        if (~el.className.indexOf('active')) {
            return;
        }
        for (let el2 of tocs) {
            if (~el2.className.indexOf('active')) {
                el2.className = el2.className.replace('active', '');
                break;
            }
        }
        el.className = el.className + ' active';
    }

    if (tocs.length) {
        for (let el of tocs) {
            el.onclick = activeToc(el);
        }
    }

    const h2s = document.querySelectorAll('.content article h2');
    const checkToc = () => {
        // 视区高度
        const viewHeight =  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        // 最近一次进入视区或划过视区的标题
        let lastInViewPort = null;
        // 上面的h的top，缓存一下
        // let lastHTop = null;

        for (let el of h2s) {
            const top = el.getBoundingClientRect() && el.getBoundingClientRect().top;
            if (viewHeight - top < 150) {
                break;
            } else {
                lastInViewPort = el;
            }
        }

        const id = lastInViewPort.id;
        const toc = document.querySelector(`.toc-item a[href="#${id}"]`);
        if (toc) {
            activeToc(toc.parentNode);
        }
    };

    checkToc();
    addEvent(document, 'scroll', checkToc);
})();